import React from 'react';
import services from '../../services';
import { toast } from 'react-toastify';

const queryString = require('query-string');

class SsoPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        // Flag na instância para bloquear o StrictMode do React
        this.isProcessingLogin = false;
    }

    componentDidMount() {
        // Se o browser já passou por aqui e iniciou o processo, NÃO DEIXA o React fazer mais nada nesta página
        if (window.loginEmCurso) {
            return;
        }

        const data = queryString.parse(this.props.location.search);
        if (data && data.code) {
            window.loginEmCurso = true; // Tranca global no browser
            this.getlogin(data);
        }
        
        this.getlogin(data);
    }

    getlogin = async (data) => {
        
        try {
            
            const resposta = await services.apiCall.requestApi('Loginsso/callback', data, 'post');

            if (resposta && resposta.user) {
                // Guarda o token retornado pelo backend
                window.localStorage.setItem('token', resposta.user.token);
                window.localStorage.setItem('username', resposta.user.fullName || resposta.user.username);
                
                toast.success("Login efetuado com sucesso!");

                // Redireciona para a página principal da aplicação
                window.location.href = '/agenda_digital';
            }

        } catch (e) {
            console.error("➔ [getlogin] Erro capturado:", e);
            window.location.href = '/login';
        }
        
    }



    resetLoginState() {
        this.isProcessingLogin = false;
        window.sessionStorage.removeItem('sso_code_usado');
        window.history.replaceState({}, document.title, window.location.pathname);
    }
    

    render() {
        return (
            <div className="dashboard">
                <div>A processar autenticação com a Microsoft...</div>
            </div>
        );
    }
}
export default SsoPage;
